/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Col, ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import * as consts from '../../const.js';
import Notification from '../common/notification/notification.component';
import { generateIteratorKey as keygen } from '../../utils/helpers';
import DocumentsService from '../documents/documents.service';

class AddNoteComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consentGid: this.props.consentGid,
      sectionName: this.props.section,
      subject: this.props.subject,
      note: this.props.description,
      consentingGid: this.props.consentingGid,
      documentsMetadata: this.props.documentsMetadata
    };
  }

  createNote = (e) => {
    let note = {
      subject: this.state.subject,
      note: this.state.note,
      sectionName: this.state.sectionName,
      type: 'DOCUMENT'
    };
    let consentingGid = this.state.consentingGid;
    this.props.createNewNote(consentingGid, note);
    e.preventDefault();
  };

  createNoteDocumentSelectItems = () => {
    let options = [];
    if (this.state.documentsMetadata) {
      for (let document of this.state.documentsMetadata) {
        if (document.consentingGid) {
          options.push(
            <option {...keygen()} value={document.consentGid}>
              {DocumentsService.buildDocumentFullName(document.consentName, document.version)}
            </option>
          );
        }
      }
    }
    return options;
  };

  onNoteDocumentSelectChanged = (event) => {
    this.state.consentGid = event.target.value;
    for (let document of this.state.documentsMetadata) {
      if (document.consentGid === this.state.consentGid) {
        this.state.consentingGid = document.consentingGid;
      }
    }
    this.props.consentDocumentSelectionChanged(this.state.consentGid);
  };

  createNoteSectionSelectItems = () => {
    let options = [];
    if (this.props.consentDocumentData) {
      let documentSections = this.props.consentDocumentData.data.consent.content.sections;
      if (documentSections) {
        for (let section of documentSections) {
          options.push(
            <option {...keygen()} value={section.name}>
              {section.name}
            </option>
          );
        }
      }
    }
    return options;
  };

  onNoteSectionChanged = (event) => {
    this.state.sectionName = event.target.value;
  };

  onNoteSubjectChanged = (event) => {
    this.setState({ subject: event.target.value });
  };

  onNoteDescriptionChanged = (event) => {
    this.setState({ note: event.target.value });
  };

  cancel = () => {
    this.props.backToView();
  };

  render() {
    let error = '';
    if (this.props.error) {
      error = <Notification type="error" data={this.props.error} />;
    }
    let body = (
      <div>
        {error}
        <Grid id="add-note-grid" fluid>
          <Form id="add-note-form" onSubmit={this.createNote}>
            <Row>
              <Col xs={6}>
                <div className="add-note-col-right">
                  <FormGroup>
                    <ControlLabel>{consts.NOTE_DOCUMENT}</ControlLabel>
                    <FormControl
                      id="addNoteDocumentSelector"
                      required
                      componentClass="select"
                      value={this.state.consentGid}
                      onChange={this.onNoteDocumentSelectChanged}
                    >
                      <option selected disabled>
                        {''}
                      </option>
                      {this.createNoteDocumentSelectItems()}
                    </FormControl>
                  </FormGroup>
                </div>
              </Col>
              <Col xs={6}>
                <div className="add-note-col-left">
                  <FormGroup controlId="noteSectionSelect">
                    <ControlLabel>{consts.NOTE_SECTION}</ControlLabel>
                    <FormControl
                      componentClass="select"
                      disabled={!this.props.consentDocumentData}
                      value={this.state.sectionName}
                      onChange={this.onNoteSectionChanged}
                    >
                      <option selected disabled>
                        {''}
                      </option>
                      {this.createNoteSectionSelectItems()}
                    </FormControl>
                  </FormGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <FormGroup>
                <ControlLabel>{consts.NOTE_SUBJECT}</ControlLabel>
                <FormControl
                  id="noteSubjectInput"
                  type="text"
                  required
                  value={this.state.subject}
                  onChange={this.onNoteSubjectChanged}
                  placeholder="Add a subject for your note"
                />
              </FormGroup>
            </Row>
            <Row>
              <FormGroup controlId="noteDescriptionTextArea">
                <ControlLabel>{consts.MESSAGE}</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  required
                  value={this.state.note}
                  onChange={this.onNoteDescriptionChanged}
                  placeholder="Add your note"
                />
              </FormGroup>
            </Row>
            <div className="edit-modal-footer">
              <hr className="edit-modal-divider" />
              <Button
                id="add-note-cancel-button"
                type="reset"
                theme="default large-button"
                handleClick={this.cancel}
                label={consts.CANCEL_BTN}
              />
              <Button id="add-note-save-button" type="submit" theme="active large-button" label={consts.SAVE_BTN} />
            </div>
          </Form>
        </Grid>
      </div>
    );

    return <div>{body}</div>;
  }
}

AddNoteComponent.propTypes = {
  noteData: PropTypes.object,
  backToView: PropTypes.func,
  createNewNote: PropTypes.func
};

export default AddNoteComponent;
